<template>
    <v-image :config="config_image"></v-image>
</template>

<script>
    import { mapState } from 'vuex'
    export default {
        name: "ClippingImage",
        props: {
            visible: {
                type: Boolean
            },
            offset: {
                type: Object,
                default: () => ({x: 0, y: 0})
            }
        },
        computed: {
            ...mapState({img: 'clipping_img'}),
            config_image: _this => (
                !_this.img ? {} : {
                    visible: typeof _this.visible === "boolean" ? _this.visible : true,
                    x: _this.offset.x,
                    y: _this.offset.y,
                    image: _this.img,
                    width: _this.img.width,
                    height: _this.img.height,
                    globalCompositeOperation: 'destination-out',
                    hitFunc: () => {}
                }
            )
        },
    }
</script>

<style scoped>

</style>
